import(/* webpackMode: "eager" */ "/app/app/(homes)/(home-new)/layout.js");
